<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="false"
    :preview-modal="false"
    :filename="`Detalhes do pagamento`"
    :pdf-quality="2"
    :manual-pagination="true"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width=""
    @progress="onProgress($event)"
    @error="onError($event)"
    @beforeDownload="beforeDownload"
    ref="html2Pdf"
  >
    <section class="v-application" slot="pdf-content">
      <div class="d-flex flex-column">
        <payment-export-reason
          :reason="reason"
          :payment="payment"
          :tickets="tickets"
          :party="party"
        />
        <payment-details-page :payment="payment" :party="party" />
        <div class="html2pdf__page"></div>
        <div v-for="ticket in tickets" :key="ticket.id">
          <ticket-details-page :ticket="ticket" :payment="payment" />
          <div class="html2pdf__page"></div>
        </div>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";
import PaymentDetailsPage from "./PaymentDetailsPage.vue";
import TicketDetailsPage from "./TicketDetailsPage.vue";
import PaymentExportReason from "./PaymentExportReason.vue";
import PARTY from "@/services/admin/party";

export default {
  components: {
    VueHtml2pdf,
    PaymentDetailsPage,
    TicketDetailsPage,
    PaymentExportReason,
  },
  data: () => ({
    tickets: [],
    reason: null,
  }),
  methods: {
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const dataUrl = reader.result;
          resolve(dataUrl);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(blob);
      });
    },
    async downloadImageAsBase64(url) {
      try {
        const blob = await this.downloadImage(url);
        return await this.blobToBase64(blob);
      } catch (error) {
        console.error("Erro ao baixar a imagem:", error);
        throw error;
      }
    },
    async downloadImage(url) {
      const response = await fetch(url);
      return await response.blob();
    },
    async downloadContent() {
      this.tickets = [];
      const ticketsIds = this.payment.Ticket.map((ticket) => ticket.id);
      for (const ticketId of ticketsIds) {
        const response = await PARTY.reports.ticketDetails(
          this.party.organizationId,
          this.party.id,
          ticketId
        );
        this.tickets.push(response.ticket);
      }
    },

    async generatePDF(reason) {
      const promise = new Promise(async (resolve, reject) => {
        try {
          this.promise = { resolve, reject };

          await this.downloadContent();
          this.reason = reason;

          this.$refs.html2Pdf.generatePdf();
        } catch (error) {
          reject(error);
        }
      });
      return promise;
    },
    onProgress(progress) {
      console.log("PDF Progress: ", progress);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      var html2PdfSetup = html2pdf().set(options).from(pdfContent);
      var pdf = await html2PdfSetup.output("blob");
      this.promise.resolve(pdf);
    },
    onError(error) {
      console.log("PDF Error: ", error);
      this.promise.reject(error);
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  props: {
    party: {
      type: Object,
      default: () => null,
    },
    payment: {
      type: Object,
      default: () => null,
    },
  },

  mounted() {
    this.$parent.$on("openExport", this.open);
  },
};
</script>

<style></style>
